require('./bootstrap')

import 'alpinejs'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.use(VueSweetalert2)

Vue.component('sweet-alert', require('./components/SweetAlert.vue').default)
Vue.component('home-slider', require('./components/HomeSlider.vue').default)
Vue.component('slides-panel', require('./components/SlidesPanel.vue').default)
Vue.component('master-form', require('./components/MasterForm.vue').default)
Vue.component('master-index', require('./components/MasterIndex.vue').default)
Vue.component('master-delete', require('./components/MasterDelete.vue').default)
Vue.component('post-form', require('./components/PostForm.vue').default)
Vue.component('post-delete', require('./components/PostDelete.vue').default)
Vue.component(
    'comments-panel',
    require('./components/CommentsPanel.vue').default
)

Vue.filter('numberFormat', value => {
    if (!value) return '0'

    const reg = /(^[+-]?\d+)(\d{3})/
    let number = value.toString()

    while (reg.test(number)) {
        number = number.replace(reg, '$1' + ',' + '$2')
    }

    return number
})

Vue.filter('phoneFormat', value => {
    if (!value) return ''

    return value.replace(
        /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
        '$1-$2-$3'
    )
})

const app = new Vue({
    el: '#app',
})
